export default __webpack_public_path__ + "static/media/Mission_img.fa2a2378.jpg";